import { IconDefinition } from '@fortawesome/fontawesome-svg-core';
import {
  faArrowRightArrowLeft,
  faBook,
  faBookOpen,
  faBoxTaped,
  faBuilding,
  faCalendar,
  faCalendarCheck,
  faCalendarDays,
  faCalendars,
  faCamera,
  faCameraRetro,
  faChartArea,
  faChartBar,
  faChartFft,
  faChartSimple,
  faClipboardCheck,
  faClipboardList,
  faCreditCard,
  faDatabase,
  faDumbbell,
  faEdit,
  faEnvelope,
  faEnvelopeOpen,
  faFile,
  faFolder,
  faGear,
  faHeartbeat,
  faHome,
  faLink,
  faLocationDot,
  faMegaphone,
  faMoneyBill,
  faPlug,
  faQuestion,
  faRobot,
  faRunning,
  faSitemap,
  faStore,
  faTable,
  faTag,
  faUser,
  faUserGear,
  faUserGroup,
  faUserPen,
  faUserTie,
  faUsers,
  faUtensils,
  faVideo,
  faWeight,
  faWeightScale,
  faWrench,
} from '@fortawesome/pro-regular-svg-icons';
import {
  faArrowRightArrowLeft as faArrowRightArrowLeftSolid,
  faBookOpen as faBookOpenSolid,
  faBook as faBookSolid,
  faBoxTaped as faBoxTapedSolid,
  faBuilding as faBuildingSolid,
  faCalendarCheck as faCalendarCheckSolid,
  faCalendarDays as faCalendarDaysSolid,
  faCalendar as faCalendarSolid,
  faCalendars as faCalendarsSolid,
  faCameraRetro as faCameraRetroSolid,
  faCamera as faCameraSolid,
  faChartArea as faChartAreaSolid,
  faChartBar as faChartBarSolid,
  faChartSimple as faChartSimpleSolid,
  faClipboardCheck as faClipboardCheckSolid,
  faClipboardList as faClipboardListSolid,
  faCreditCard as faCreditCardSolid,
  faDatabase as faDatabaseSolid,
  faDumbbell as faDumbbellSolid,
  faEdit as faEditSolid,
  faEnvelopeOpen as faEnvelopeOpenSolid,
  faEnvelope as faEnvelopeSolid,
  faFile as faFileSolid,
  faFolder as faFolderSolid,
  faGear as faGearSolid,
  faHeartbeat as faHeartbeatSolid,
  faHome as faHomeSolid,
  faLink as faLinkSolid,
  faLocationDot as faLocationDotSolid,
  faMegaphone as faMegaphoneSolid,
  faMoneyBill as faMoneyBillSolid,
  faPlug as faPlugSolid,
  faQuestion as faQuestionSolid,
  faRobot as faRobotSolid,
  faRunning as faRunningSolid,
  faSitemap as faSitemapSolid,
  faStore as faStoreSolid,
  faTable as faTableSolid,
  faTag as faTagSolid,
  faUserGear as faUserGearSolid,
  faUserGroup as faUserGroupSolid,
  faUserPen as faUserPenSolid,
  faUser as faUserSolid,
  faUserTie as faUserTieSolid,
  faUsers as faUsersSolid,
  faUtensils as faUtensilsSolid,
  faVideo as faVideoSolid,
  faWeightScale as faWeightScaleSolid,
  faWeight as faWeightSolid,
  faWrench as faWrenchSolid,
  faChartFft as faChartFftSolid,
} from '@fortawesome/pro-solid-svg-icons';

export const defaultIcon = faFile;

const solidIconByName: Record<string, IconDefinition> = {
  [faArrowRightArrowLeft.iconName]: faArrowRightArrowLeftSolid,
  [faBook.iconName]: faBookSolid,
  [faBookOpen.iconName]: faBookOpenSolid,
  [faBoxTaped.iconName]: faBoxTapedSolid,
  [faBuilding.iconName]: faBuildingSolid,
  [faCalendar.iconName]: faCalendarSolid,
  [faCalendarCheck.iconName]: faCalendarCheckSolid,
  [faCalendarDays.iconName]: faCalendarDaysSolid,
  [faCamera.iconName]: faCameraSolid,
  [faCameraRetro.iconName]: faCameraRetroSolid,
  [faChartArea.iconName]: faChartAreaSolid,
  [faChartBar.iconName]: faChartBarSolid,
  [faChartSimple.iconName]: faChartSimpleSolid,
  [faClipboardCheck.iconName]: faClipboardCheckSolid,
  [faClipboardList.iconName]: faClipboardListSolid,
  [faCreditCard.iconName]: faCreditCardSolid,
  [faDatabase.iconName]: faDatabaseSolid,
  [faDumbbell.iconName]: faDumbbellSolid,
  [faEdit.iconName]: faEditSolid,
  [faEnvelope.iconName]: faEnvelopeSolid,
  [faEnvelopeOpen.iconName]: faEnvelopeOpenSolid,
  [faFile.iconName]: faFileSolid,
  [faFolder.iconName]: faFolderSolid,
  [faGear.iconName]: faGearSolid,
  [faHeartbeat.iconName]: faHeartbeatSolid,
  [faHome.iconName]: faHomeSolid,
  [faLink.iconName]: faLinkSolid,
  [faLocationDot.iconName]: faLocationDotSolid,
  [faMegaphone.iconName]: faMegaphoneSolid,
  [faMoneyBill.iconName]: faMoneyBillSolid,
  [faPlug.iconName]: faPlugSolid,
  [faQuestion.iconName]: faQuestionSolid,
  [faRobot.iconName]: faRobotSolid,
  [faRunning.iconName]: faRunningSolid,
  [faSitemap.iconName]: faSitemapSolid,
  [faStore.iconName]: faStoreSolid,
  [faTable.iconName]: faTableSolid,
  [faTag.iconName]: faTagSolid,
  [faUser.iconName]: faUserSolid,
  [faUserGear.iconName]: faUserGearSolid,
  [faUserGroup.iconName]: faUserGroupSolid,
  [faUserPen.iconName]: faUserPenSolid,
  [faUserTie.iconName]: faUserTieSolid,
  [faUsers.iconName]: faUsersSolid,
  [faUtensils.iconName]: faUtensilsSolid,
  [faVideo.iconName]: faVideoSolid,
  [faWeight.iconName]: faWeightSolid,
  [faWeightScale.iconName]: faWeightScaleSolid,
  [faWrench.iconName]: faWrenchSolid,
  [faChartFft.iconName]: faChartFftSolid,
  [faCalendars.iconName]: faCalendarsSolid,
};

export const getSolidIcon = (icon?: IconDefinition) => {
  return icon ? solidIconByName[icon.iconName] || icon : undefined;
};

export const routesExtraData = {
  'Data Loads': {
    icon: faDatabase,
    reactRoute: '/data-loads',
    enabled: true,
  },
  Stripe: {
    reactRoute: '/stripe/payment-plans',
    icon: faCreditCard,
  },
  Messages: {
    icon: faEnvelope,
    reactRoute: '/messages',
  },
  Appointments: {
    icon: faBook,
    reactRoute: '/appointments',
  },
  'Time Card': {
    icon: faBook,
    reactRoute: '/time-tracking',
  },
  Lifecycle: {
    icon: faHeartbeat,
    reactRoute: '/lifecycle',
  },
  Products: {
    icon: faBoxTaped,
    reactRoute: '/products',
    children: [
      {
        id: 'products',
        reactRoute: '/products',
        name: 'Products',
        enabled: true,
      },
      {
        id: 'manage-inventory',
        reactRoute: '/products/inventory',
        name: 'Inventory',
        enabled: true,
      },
    ],
  },
  Reports: {
    icon: faChartBar,
    reactRoute: '/reports',
  },
  'Franchise Fees': {
    icon: faMoneyBill,
    reactRoute: '/franchise-fees',
    enabled: true,
  },
  Dashboard: {
    icon: faHome,
    reactRoute: '/dashboard',
  },
  Plans: {
    icon: faClipboardList,
    reactRoute: '/workout-plans',
  },
  Exercises: {
    icon: faDumbbell,
    reactRoute: '/exercises',
  },
  Groups: {
    icon: faUsers,
    reactRoute: '/groups',
  },
  Clients: {
    icon: faUser,
    reactRoute: '/clients',
  },
  Packages: {
    icon: faBoxTaped,
    route: '/fbm/packages',
  },
  Services: {
    icon: faClipboardList,
    route: '/fbm/services',
  },
  Onboarding: {
    icon: faUser,
    reactRoute: '/onboarding',
  },
  Emails: {
    icon: faEnvelope,
    reactRoute: '/emails',
  },
  'Platform Hierarchy': {
    icon: faSitemap,
    reactRoute: '/sites/hierarchy',
  },
  Sites: {
    icon: faLocationDot,
    reactRoute: '/sites',
    enabled: true,
  },
  Schedule: {
    icon: faCalendar,
    children: [
      {
        id: 'calendar',
        route: '/fbm/schedule',
        name: 'Calendar',
        enabled: true,
      },
      {
        id: 'visits',
        reactRoute: '/fbm/visits',
        name: 'Visits',
        enabled: true,
      },
      {
        id: 'members',
        reactRoute: '/fbm/scheduled-members',
        name: 'Recurring Members',
        enabled: true,
      },
      {
        id: 'services',
        reactRoute: '/fbm/services',
        name: 'Services',
        enabled: true,
      },
      {
        id: 'packages',
        reactRoute: '/fbm/packages',
        name: 'Packages',
        enabled: true,
      },
      {
        id: 'locations',
        reactRoute: '/fbm/locations',
        name: 'Locations',
        enabled: true,
      },
      {
        id: 'schedules',
        reactRoute: '/fbm/schedules',
        name: 'Availability Schedules',
        enabled: true,
      },
    ],
  },
  'Site Configuration': {
    icon: faGear,
    route: '/dashboard/trainer/custom',
    children: [
      {
        id: 'customize platform',
        route: '/dashboard/trainer/custom',
        name: 'Customize Platform',
        reactRoute: '/settings/platform',
        enabled: true,
      },
      {
        id: 'manage-roles',
        route: '/dashboard/roles-management',
        name: 'Staff Roles',
        reactRoute: '/site-configuration/roles',
        enabled: true,
      },
      {
        id: 'navigation',
        reactRoute: '/site-configuration/navigation',
        name: 'Navigation Menu Settings',
        enabled: true,
      },
      {
        id: 'habits',
        reactRoute: '/site-configuration/habits',
        name: 'Habits',
        enabled: true,
      },
      {
        id: 'tags',
        reactRoute: '/site-configuration/tags',
        name: 'Tags',
        enabled: true,
      },
      {
        id: 'lifecycle',
        reactRoute: '/lifecycle',
        name: 'Lifecycle',
        enabled: true,
      },
      {
        id: 'reports',
        reactRoute: '/site-configuration/reports',
        name: 'Reports',
        enabled: true,
      },
      {
        id: 'resources',
        reactRoute: '/site-configuration/resources',
        name: 'Resources',
        enabled: true,
      },
    ],
  },
  Account: {
    icon: faUserGear,
  },
  People: {
    icon: faUsers,
  },
  Programming: {
    icon: faDumbbell,
  },
  Offerings: {
    icon: faClipboardList,
  },
  Connect: {
    icon: faMegaphone,
  },
  Settings: {
    icon: faGear,
  },
  Booking: {
    icon: faBook,
  },
  Automations: {
    icon: faRobot,
    reactRoute: '/automations',
  },
  Journal: {
    icon: faBook,
    reactRoute: '/me/journal',
  },
  Activity: {
    icon: faRunning,
    reactRoute: '/activity',
  },
  Performance: {
    icon: faChartFft,
    reactRoute: '/me/performance',
  },
  Snapshot: {
    icon: faCamera,
    reactRoute: '/me/snapshots',
  },
  Measurements: {
    icon: faWeightScale,
    reactRoute: '/me/health',
  },
  Tags: {
    icon: faTag,
    reactRoute: '/tags',
  },
  Resources: {
    icon: faFolder,
    reactRoute: '/resources',
  },
  Assessments: {
    icon: faClipboardCheck,
    reactRoute: '/trainer/assessments/',
  },
  'My Stuff': {
    icon: faUser,
  },
  'My Measurements': {
    icon: faWeightScale,
    reactRoute: '/me/measurements',
  },
  Visits: {
    icon: faCalendarCheck,
    reactRoute: '/me/visits',
  },
  'My Assessments': {
    icon: faClipboardCheck,
    reactRoute: '/me/assessments',
  },
  'My Videos': {
    icon: faVideo,
    reactRoute: '/me/videos',
  },
  Dependents: {
    icon: faUserGroup,
    reactRoute: '/me/dependents',
  },
  'My Progress Photos': {
    icon: faCameraRetro,
    reactRoute: '/me/progress-photos',
  },
  'My Nutrition': {
    icon: faUtensils,
    reactRoute: '/me/nutrition',
  },
  'My Resources': {
    icon: faBookOpen,
    reactRoute: '/me/resources',
  },
  'My Packages': {
    icon: faBoxTaped,
    reactRoute: '/me/packages',
  },
  'My Groups': {
    icon: faUsers,
    reactRoute: '/me/groups',
  },
  'My Rep Maxes': {
    icon: faWeightScale,
    reactRoute: '/me/rep-maxes',
  },
  'Point of Sale': {
    icon: faCreditCard,
    reactRoute: '/pos-config/settings',
  },
  'Edit Profile': {
    icon: faUserPen,
    reactRoute: '/me/profile',
  },
  'Trainer Info': {
    icon: faUserTie,
    reactRoute: '/me/profile',
  },
  'My Workout Plans': {
    icon: faBoxTaped,
    reactRoute: '/me/workout-plans',
  },
  Trainers: {
    icon: faUsers,
    reactRoute: '/staff',
  },
  'Connected Apps': {
    icon: faPlug,
    reactRoute: '/me/apps',
  },
  'My Connected Apps': {
    icon: faPlug,
    reactRoute: '/me/apps',
  },
  'My Products': {
    icon: faBoxTaped,
    reactRoute: '/me/products',
  },
  Support: {
    icon: faQuestion,
    reactRoute: '/support',
  },
  Links: {
    icon: faLink,
    reactRoute: '/links',
  },
  Events: {
    icon: faCalendarDays,
    reactRoute: '/events',
  },
  Videos: {
    icon: faVideo,
    reactRoute: '/videos',
  },
  'Measurement Reports': {
    icon: faTable,
    reactRoute: '/health/reports',
  },
  'Customize Platform': {
    icon: faGear,
    reactRoute: '/settings/platform',
  },
};

export const clientRoutesExtraData = {
  Journal: {
    icon: faHome,
  },
  Packages: {
    icon: faBoxTaped,
    externalLink: true,
    reactRoute: '/a/packages',
  },
  Exercises: {
    icon: faDumbbell,
    reactRoute: '/finders/exercises',
    externalLink: false,
  },
  Groups: {
    icon: faUsers,
    reactRoute: '/finders/groups',
    externalLink: false,
  },
  Plans: {
    icon: faDumbbell,
    reactRoute: '/finders/plans',
    externalLink: false,
  },
  Products: {
    icon: faBoxTaped,
    reactRoute: '/purchase/products',
    externalLink: false,
  },
  Shop: {
    icon: faStore,
    externalLink: false,
  },
  Resources: {
    icon: faFolder,
    externalLink: false,
  },
  Booking: {
    icon: faCalendars,
    externalLink: true,
    reactRoute: '/a/booking',
  },
};
